import './Status.sass';

import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { BottomBar } from '$uikit';
import { useCurrentUserInfo, useGroupInfo, useTranslator } from '$hooks';
import { profileActions } from '$store/profile';

const MAX_LEN = 120;

export function Status({ groupId = 0 }: { groupId?: number }) {
  const user = useCurrentUserInfo();
  const group = useGroupInfo(groupId);
  const [text, setText] = useState(groupId ? group?.status ?? '' : user.status);
  const [isPublish, setPublish] = useState(false);
  const dispatch = useDispatch();
  const t = useTranslator();

  const availLen = useMemo(() => {
    return MAX_LEN - text.length;
  }, [text]);

  const handleChange = useCallback(
    ({ target }) => {
      setText(target.value.slice(0, MAX_LEN));
    },
    [setText],
  );

  const handleSave = useCallback(() => {
    dispatch(profileActions.setStatus({ text, isPublish, groupId }));
  }, [text, dispatch, isPublish, groupId]);

  const handlePublish = useCallback(() => {
    setPublish(!isPublish);
  }, [setPublish, isPublish]);

  return (
    <>
      <Header showCloseButton>{t('status_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem description={t('symbols_limit', { count: availLen })}>
            <Input
              placeholder={t('status_placeholder')}
              value={text}
              onChange={handleChange}
              maxLength={MAX_LEN}
            />
          </FormItem>
          {/*<FormItem>*/}
          {/*  <Checkbox*/}
          {/*    checked={isPublish}*/}
          {/*    onClick={handlePublish}*/}
          {/*  >*/}
          {/*    {t('status_publish_post')}*/}
          {/*  </Checkbox>*/}
          {/*</FormItem>*/}
        </Form>
      </ScrollView>
      <BottomBar>
        <Button stretched onClick={handleSave}>
          {t('save')}
        </Button>
      </BottomBar>
    </>
  );
}
